import { handleError, handleGetRequest, handleSuccess, triggerGet, triggerPost, triggerPut } from './utils';

export const getCalendarRequest = async (dateFrom, dateTo, resourceId = null) => {
  return handleGetRequest(`/business/calendar/${dateFrom}/${dateTo}/` + (resourceId ?? ''));
};

export const getReservationRequest = async id => {
  const apiResponse = await triggerGet('/business/reservations/' + id);
  const responseData = await apiResponse.json();
  if ([200, 201].includes(responseData.report.status)) {
    return handleSuccess(responseData);
  }
  return handleError(responseData);
};

export const createReservationRequest = async data => {
  const apiResponse = await triggerPost('/business/reservations', data);
  const responseData = await apiResponse.json();
  if ([200, 201].includes(responseData.report.status)) {
    return handleSuccess(responseData);
  }
  return handleError(responseData);
};

export const updateReservationRequest = async (data, id) => {
  const apiResponse = await triggerPut('/business/reservations/' + id, data);
  const responseData = await apiResponse.json();
  if ([200, 201].includes(responseData.report.status)) {
    return handleSuccess(responseData);
  }
  return handleError(responseData);
};

export const getResourceScheduleRequest = async id => {
  const apiResponse = await triggerGet('/business/schedules/' + id);
  const responseData = await apiResponse.json();
  if ([200, 201].includes(responseData.report.status)) {
    return handleSuccess(responseData);
  }
  return handleError(responseData);
};
